/**
 * This bundle's identity, injected at build time by vite.config.ts.
 *
 * Sent with every client error report so error_log.build_id says which
 * artifact produced the row — see shared/buildId.ts for why that column sat
 * NULL for months and what it cost.
 *
 * The fallback matters: `define` replaces this literally at build time, so a
 * dev server or a test run that never went through the build has nothing to
 * substitute. "unknown" is honest; guessing a version would be worse than
 * admitting we do not know.
 *
 * The guard matters too: under plain node (the tsx lib suites, which load
 * lib/ocrEngine and so this module since 2026-10-25) there is no Vite and
 * `import.meta.env` is undefined, so the bare read threw at import and took
 * 14 suites down. The member expression stays spelled out in full, because
 * Vite's `define` matches that exact shape and nothing else.
 */
const env = import.meta.env as Record<string, string | undefined> | undefined;
const injected = env ? (import.meta.env.VITE_BUILD_ID as string | undefined) : undefined;

export const BUILD_ID: string =
  typeof injected === "string" && injected.length > 0 ? injected : "unknown";
